export const DetailType = {
  List: 'List',
  Details: 'Details',
};

export const DetailTypeOptions = [
  { value: DetailType.List, label: DetailType.List },
  { value: DetailType.Details, label: DetailType.Details },
];



// WEBPACK FOOTER //
// ./src/pages/billingaccount/constants/index.js